import { Timecode } from '@iconik-io/core/src/timecode.js';

import type { PlaylistItem } from '../types.js';

export const getFrameAlignedTime = (
  time: number,
  playlistItem: PlaylistItem,
) => {
  let frameRate = playlistItem.frameRate;
  if (playlistItem.contentType === 'audio') {
    frameRate = 1000;
  }
  if (!playlistItem || !frameRate) {
    return 0;
  }
  const timecode = new Timecode(
    {
      frameRate,
      isDropFrame: playlistItem.isDropFrame,
      isMillisecondsMode: playlistItem.contentType === 'audio',
    },
    { seconds: time },
  );

  return timecode.toSeconds();
};
